import request from '@/utils/request'

// --- 数据类型 ---

/** 技能项（列表单项） */
export interface SkillItem {
  id: number
  name: string
  skillName: string
  description: string
  avatar: string
  categoryId: number
  categoryName: string
  useCount: number
  sort: number
  data: string
  added: boolean
}

/** 通用响应结构 */
export interface Res<T> {
  code: number
  message?: string
  msg?: string
  data: T
}

/** 通用空 data 响应 */
export type SkillEmptyRes = Res<string | null>

/** 技能列表响应 */
export type SkillListRes = Res<SkillItem[]>

/** 技能广场列表响应 */
export type ListSkillsRes = SkillListRes

/** 技能分类单项 */
export interface SkillCategoryItem {
  id: number
  name: string
  icon: string
  sort: number
}

/** 技能分类列表响应 */
export type ListCategoriesRes = Res<SkillCategoryItem[]>

/** 斜杠命令列表响应 */
export type SkillSlashCommandListRes = Res<SkillItem[]>

/** 修改技能配置参数 */
export interface UpdateSkillConfigParams {
  [key: string]: unknown
}

/** 修改技能配置响应 */
export type UpdateSkillConfigRes = Res<string | null>

/** 获取技能配置列表参数 */
export interface ListSkillConfigsParams {
  [key: string]: unknown
}

/** 获取技能配置列表响应 */
export type ListSkillConfigsRes = Res<SkillItem[]>

// --- 接口 ---

/**
 * 添加技能
 * @param skillId 技能ID
 */
export function addSkill(skillId: number): Promise<SkillEmptyRes> {
  return request.post(`/ai-api/v1/skill/add?skillId=${skillId}`)
}

/**
 * 技能广场列表
 * @param categoryId 分类ID（来自 /anon/categories）
 * @param pageNum 页码，从1开始，默认1
 * @param pageSize 每页条数，默认20
 */
export function listSkills(categoryId?: number | '', pageNum = 1, pageSize = 20): Promise<ListSkillsRes> {
  const query = new URLSearchParams()
  if (categoryId !== undefined && categoryId !== '') {
    query.append('categoryId', String(categoryId))
  }
  query.append('pageNum', String(pageNum))
  query.append('pageSize', String(pageSize))
  return request.get(`/ai-api/v1/skill/anon/list?${query.toString()}`)
}

/**
 * 技能分类列表
 */
export function listCategories(): Promise<ListCategoriesRes> {
  return request.get('/ai-api/v1/skill/anon/categories')
}

/**
 * 移除技能
 * @param skillId 技能ID
 */
export function removeSkill(skillId: number): Promise<SkillEmptyRes> {
  return request.delete(`/ai-api/v1/skill/remove?skillId=${skillId}`)
}

/**
 * 获取匿名斜杠命令配置列表（仅返回启用项）
 */
export function listAnonSlashCommands(): Promise<SkillSlashCommandListRes> {
  return request.get('/ai-api/v1/skill/my')
}

/**
 * 修改技能配置
 * @param id 技能 ID
 * @param params 修改参数
 */
export function updateSkillConfig(id: number, params: UpdateSkillConfigParams): Promise<UpdateSkillConfigRes> {
  return request.post(`/ai-api/v1/skill/update/config/${id}`, params, {
    headers: {
      token: 'pKBzZ0cHfAfo&I;eNO;VI'
    }
  })
}

/**
 * 获取所有技能配置
 * @param skillId 技能 ID
 * @param params 额外查询参数（可选）
 */
export function listSkillConfigs(skillId?: number, params?: ListSkillConfigsParams): Promise<ListSkillConfigsRes> {
  return request.get('/ai-api/v1/skill/getAll/config', {
    params: {
      skillId,
      ...(params ?? {})
    },
    headers: {
      token: 'pKBzZ0cHfAfo&I;eNO;VI'
    }
  })
}
